module.exports = window.wp.wordcount;